module.exports = __webpack_public_path__ + "static/media/signup-icon.97d20efc.svg";